function cov_jefvpc913() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MultipleOffersFilled.tsx";
  var hash = "11c5894fee032749727b3273fa63ca0979d368e3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MultipleOffersFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 61
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "11c5894fee032749727b3273fa63ca0979d368e3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_jefvpc913 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_jefvpc913();
var Icon = (cov_jefvpc913().s[0]++, {
  name: 'multiple-ofers-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.75 5C7.75 3.20507 9.20507 1.75 11 1.75H18.4C20.1949 1.75 21.65 3.20507 21.65 5V15.6C21.65 17.3397 20.2397 18.75 18.5 18.75V16.25C18.859 16.25 19.15 15.959 19.15 15.6V5C19.15 4.58579 18.8142 4.25 18.4 4.25H11C10.5858 4.25 10.25 4.58579 10.25 5H7.75Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.4 6C4.07452 6 3 7.07452 3 8.4V19.6C3 20.9255 4.07452 22 5.4 22H15C16.3255 22 17.4 20.9255 17.4 19.6V8.4C17.4 7.07452 16.3255 6 15 6H5.4ZM8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14ZM8 16.3604C7.44772 16.3604 7 16.8081 7 17.3604C7 17.9126 7.44772 18.3604 8 18.3604H12C12.5523 18.3604 13 17.9126 13 17.3604C13 16.8081 12.5523 16.3604 12 16.3604H8Z\" fill=\"currentColor\"/>"
});
export default Icon;